import { Component, Input, OnInit } from '@angular/core';
import { db_tables } from '@app/consts';
import { TableField } from '@app/modules/security-setup/models/table-field.model';
import { SecuritySetupService } from '@app/modules/security-setup/services/security-setup.service';

@Component({
  selector: 'app-buy-sell-plan-details',
  templateUrl: './buy-sell-plan-details.component.html',
  styleUrls: ['./buy-sell-plan-details.component.scss']
})
export class BuySellPlanDetailsComponent implements OnInit {
  @Input() buySellPlan: any;
  loadingTableField: boolean;
  dbTableFields: TableField[];

  constructor(
    private securitySetupService: SecuritySetupService
  ) { }

  ngOnInit(): void {
    this.getFields(db_tables.BuySellPlans);
  }

  getFields(tableId) {
    this.loadingTableField = true;

    this.securitySetupService.getFields(tableId, 100, 0)
      .subscribe({
        next: (response) => {
          this.loadingTableField = false;
          this.dbTableFields = response.data;
        },
        error: (error) => {
          this.loadingTableField = false;
        }
      });
  }

  getFieldName(fieldId: string): string {
    const field = this.dbTableFields?.find(f => f.id === fieldId);
    return field ? field.name : fieldId;
  }

}
